import { AccountRow } from '~/app/accounts/types'
import { CurrencyAmount } from '~/components/component-library'

export const AutomationAccountProcessed = ({
  account,
}: {
  account: AccountRow
}) => {
  if (!account.automation) return null

  return (
    <CurrencyAmount
      value={account.automation.totalProcessedUsd ?? 0}
      layout="inline"
    />
  )
}
